{
  "cancel": "Cancel",
  "pendingText": "This may take a while - Please wait.",
  "delete": "Delete",
  "login": "Sign In",
  "close": "Close",
  "required": "This field cannot be empty",
  "chatNewMessage": "New message",
  "chatCloseNotification": "Close notification",
  "noMoreArticles": "No more articles"
}
